module.exports = __webpack_public_path__ + "static/media/MA.f3292448.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/MA.svg
// module id = 307
// module chunks = 0